<template>
  <div :menu-fix="false">
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.supplierSettlements'), $t('text.create')]"
      ></breadcrumb>
      <div class="container">
        <el-form
          ref="settleObjForm"
          :model="settleObj"
          label-width="100px"
          size="small"
        >
          <div class="pd20">
            <fieldset>
              <legend>
                {{ $t("text.baseInfo") }}
              </legend>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('settlement.title')">{{
                    settleObj.title
                  }}</el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item :label="$t('settlement.amount')">
                    {{ settleObj.amount | currency }}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('settlement.purchaseQuantity')">{{
                    settleObj.orderQuantity
                  }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('menu.suppliers')">{{
                    settleObj.supplierName
                  }}</el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item :label="$t('settlement.searchCondition')">{{
                    settleObj.searchCondition
                  }}</el-form-item>
                </el-col>
              </el-row>
            </fieldset>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>
    </div>
    <div class="wrapper table-area">
      <fieldset>
        <legend>
          {{ $t("text.detail") }}
          <span
            v-if="purchases.filter((p) => p.manualSettleAt != null).length != 0"
            class="orange font10"
          >
            共{{ purchases.length }}条,{{
              purchases.filter((p) => p.manualSettleAt != null).length
            }}条标记结算
          </span>
        </legend>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="全部" name="all"></el-tab-pane>
          <el-tab-pane :label="$t('action.rework')" name="rework"></el-tab-pane>
        </el-tabs>
        <vxe-table
          :data="showPurchses"
          ref="itemsTable"
          class="recordsTable"
          size="mini"
          :scroll-y="{ enabled: false }"
          highlight-hover-row
        >
          <vxe-table-column
            field="images"
            :title="$t('product.images')"
            width="85"
          >
            <template v-slot="{ row }">
              <thumbnail :images="row.images"></thumbnail>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="serialNo"
            :title="$t('text.serialNo')"
            min-width="100"
          >
            <template v-slot="{ row }">
              <span class="blue" @click="showPurchase(row)">
                {{ row.serialNo }}
              </span>
              <div>
                <state-label :state="row.workflowState">{{
                  $t("purchaseStates." + row.workflowState)
                }}</state-label>
                <div v-if="row.manualSettleAt !== null" class="green font10">
                  {{ $t("delivery.settle") }}
                </div>
              </div>
            </template>
          </vxe-table-column>

          <vxe-table-column
            field="giveAt"
            :title="$t('purchase.giveAt')"
            min-width="110"
          >
            <template v-slot="{ row }">
              {{ row.giveAt }}
              <div class="font10">
                {{ $t("text.handOverAt2") }}:{{ row.handOverAt }}
              </div>
              <div
                v-if="!['finished', 'untrod'].includes(row.workflowState)"
                :class="
                  Util.dateDiff(row.handOverAt, new Date()) > 0 ? '' : 'red'
                "
                class="font10"
              >
                {{ $t("text.handOverAtDateMinus")
                }}{{ Util.dateDiff(row.handOverAt, new Date()) }}天
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="supplierDeliveryAt"
            :title="$t('dateTypes.supplierDeliveryAt')"
            min-width="120"
          >
            <template v-slot="{ row }">
              {{ row.finishAt }}
              <div v-if="row.receiveHandDiffDay > 0" class="font10">
                {{ $t("purchase.receiveHandDiffDay")
                }}{{ row.receiveHandDiffDay }}天
              </div>
            </template>
          </vxe-table-column>

          <vxe-table-column
            field="productNo"
            :title="$t('product.productNo')"
            min-width="100"
          >
            <template v-slot="{ row }">
              {{ row.productNo }}
              <div class="font10">{{ row.color }} {{ row.size }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="remark"
            :title="$t('text.remark')"
            min-width="80"
          >
            <template v-slot="{ row }">
              <raw-html-limit-number
                :content="row.remark"
                :number="12"
                type="richText"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="specJson"
            :title="$t('product.specJson')"
            min-width="90"
          >
            <template v-slot="{ row }">
              <attribute :content="row.specJson" :number="12" />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="quantity"
            :title="$t('text.quantity')"
            min-width="100"
          >
            <template v-slot="{ row }">
              {{ row.quantity }}{{ row.unit }}
              <div class="font10">
                {{ $t("purchase.receiveQuantity") }}: {{ row.receiveQuantity
                }}{{ row.unit }}
              </div>
              <div
                v-if="row.qualityQuantity != null && row.qualityQuantity != 0"
                class="font10"
              >
                {{ $t("purchase.qualityQuantity") }}:{{ row.qualityQuantity
                }}{{ row.unit }}
              </div>
              <div
                v-if="row.reworkQuantity != null && row.reworkQuantity != 0"
                class="font10 red"
              >
                {{ $t("purchase.reworkQuantity") }}:{{ row.reworkQuantity
                }}{{ row.unit }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column :title="$t('order.price')" min-width="80">
            <template v-slot="{ row }">
              {{ row.price | currency }}
              <div
                class="font10"
                v-if="
                  row.supplierQuotedPrice != null &&
                  row.supplierQuotedPrice != ''
                "
              >
                {{ $t("product.quotation") }}:
                {{ row.supplierQuotedPrice | currency }}
              </div>
              <div
                class="font10 orange"
                v-if="
                  row.changeAt != null &&
                  row.purchaseChange != null &&
                  row.purchaseChange.acceptAt == null
                "
              >
                <el-popover
                  placement="right"
                  width="300"
                  trigger="click"
                  class="mgr5"
                >
                  <div>
                    <div class="lineH24">
                      {{ $t("allocate.applyName") }}：{{
                        row.purchaseChange.applyName
                      }}
                    </div>
                    <div class="lineH24">
                      {{ $t("allocate.applyAt") }}：{{
                        row.purchaseChange.applyAt
                      }}
                    </div>
                    <div class="lineH24">
                      {{ $t("allocate.applyRemark") }}：{{
                        row.purchaseChange.applyRemark
                      }}
                    </div>

                    <div
                      class="lineH24"
                      v-if="row.purchaseChange.acceptName != null"
                    >
                      {{ $t("allocate.acceptName") }}：{{
                        row.purchaseChange.acceptName
                      }}
                    </div>
                    <div
                      class="lineH24"
                      v-if="row.purchaseChange.acceptAt !== null"
                    >
                      {{ $t("allocate.acceptAt") }}：{{
                        row.purchaseChange.acceptAt
                      }}
                    </div>
                    <div
                      class="lineH24"
                      v-if="row.purchaseChange.rejectAt !== null"
                    >
                      {{ $t("allocate.acceptAt") }}：{{
                        row.purchaseChange.rejectAt
                      }}
                    </div>
                    <div
                      class="lineH24"
                      v-if="row.purchaseChange.rejectAt !== null"
                    >
                      {{ $t("allocate.rejectReason") }}：{{
                        row.purchaseChange.rejectReason
                      }}
                    </div>
                  </div>
                  <span
                    slot="reference"
                    class="popover-reference orange font10"
                  >
                    <span
                      v-if="
                        row.purchaseChange.rejectAt == null &&
                        row.purchaseChange.acceptAt == null
                      "
                    >
                      供应商待审:{{ row.purchaseChange.newValue | currency }}
                    </span>
                    <span v-if="row.purchaseChange.rejectAt !== null">
                      供应商拒绝:{{ row.purchaseChange.newValue | currency }}
                    </span>
                  </span>
                </el-popover>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column :title="$t('order.subtotal')" min-width="80">
            <template v-slot="{ row }">
              {{ (row.price * row.quantity) | currency }}
            </template>
          </vxe-table-column>

          <vxe-table-column
            :title="$t('order.settlementRemark')"
            min-width="80"
          >
            <template v-slot="{ row }">
              <raw-html-limit-number
                :content="row.settlementRemark"
                :number="8"
              />
            </template>
          </vxe-table-column>

          <vxe-table-column
            :title="$t('settlement.settleTotal')"
            min-width="120"
          >
            <template v-slot="{ row }">
              <el-input
                size="small"
                v-model="row.settleTotal"
                width="100"
                @blur="computeAmount"
              />
              <el-input
                v-model="row.explain"
                size="small"
                width="100"
                :placeholder="$t('settlement.explain')"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="action"
            :title="$t('text.action')"
            width="50"
          >
            <template v-slot="{ row, rowIndex }">
              <el-button type="text" size="mini" @click="remove(row, rowIndex)">
                {{ $t("text.remove") }}
              </el-button>
            </template>
          </vxe-table-column>
        </vxe-table>
      </fieldset>
    </div>

    <drawer
      :title="$t('text.view', [$t('menu.purchases')])"
      :visible.sync="showPurchaseDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-purchase :id="currentRowPurchaseId" />
    </drawer>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import BackButton from "@/components/BackButton";
import Narrow from "@/components/Narrow";

//
import Purchase from "@/api/purchase.js";
import Supplier from "@/api/supplier.js";
import Settlement from "@/api/settlement.js";
import ShowPurchase from "./showPurchase";

export default {
  mixins: [page],
  components: {
    BackButton,
    ShowPurchase,
    Narrow,
  },
  data() {
    return {
      supplier: null,
      purchases: [],
      showPurchses: [],
      Util: Util,
      settleObj: {
        title: null,
        supplierId: null,
        supplierName: null,
        supplierTenantId: null,
        amount: null,
        settlementItems: [],
        currency: null,
        orderQuantity: null,
        productQuantity: null,
        settleType: "Purchase",
      },

      saveDoing: false,
      //
      currentRowPurchaseId: null,
      showPurchaseDF: false,
      activeName: "all",
    };
  },
  mounted() {},
  created() {
    const self = this;
    if (self.$route.query.placeAtStartAt !== undefined) {
      self.settleObj.searchCondition =
        "下单日期:" +
        self.$route.query.placeAtStartAt +
        "~" +
        self.$route.query.placeAtEndAt;
    }
    if (self.$route.query.receiveAtStartAt !== undefined) {
      self.settleObj.searchCondition =
        "收货日期:" +
        self.$route.query.receiveAtStartAt +
        "~" +
        self.$route.query.receiveAtEndAt;
    }
    if (self.$route.query.supplierDeliveryAtStartAt !== undefined) {
      self.settleObj.searchCondition =
        "供应商发货日期:" +
        self.$route.query.supplierDeliveryAtStartAt +
        "~" +
        self.$route.query.supplierDeliveryAtEndAt;
    }
    self.loadingStart();
    self.settleObj.title = self.$route.params.title;
    axios
      .all([
        Supplier.findById(self.$route.query.supplierId),
        Purchase.unSettle(self.$route.query),
      ])
      .then(
        axios.spread(function (suppliers, purchases) {
          self.loadingEnd();
          if (suppliers.data.code === 200) {
            self.supplier = suppliers.data.entity;
            self.settleObj.supplierId = parseInt(self.$route.query.supplierId);
            self.settleObj.supplierName = self.supplier.name;
            self.settleObj.supplierTenantId = self.supplier.sourceTenantId;
          } else {
            self.sysError();
          }
          if (purchases.status === 200) {
            self.purchases = purchases.data.filter(
              (p) => p.workflowState !== "newly"
            );
            for (const p of self.purchases) {
              Vue.set(p, "explain", null);
              if (["canceled", "untrod"].includes(p.workflowState)) {
                Vue.set(p, "settleTotal", 0);
              }
              if (
                (p.price == 0 || p.price == null) &&
                p.supplierQuotedPrice != 0 &&
                p.supplierQuotedPrice != ""
              ) {
                Vue.set(p, "settleTotal", p.supplierQuotedPrice * p.quantity);
              } else {
                Vue.set(p, "settleTotal", p.price * p.quantity);
              }
            }
            self.showPurchses = self.purchases;
          } else {
            self.sysError();
          }
          self.computeAmount();
        })
      );
  },

  methods: {
    handleClick(tab, event) {
      if (this.activeName == "rework") {
        this.showPurchses = this.purchases.filter(
          (p) => p.reworkQuantity != null && p.reworkQuantity != 0
        );
      } else {
        this.showPurchses = this.purchases;
      }
    },

    showPurchase(row) {
      this.currentRowPurchaseId = row.id;
      this.showPurchaseDF = true;
    },
    remove(row, rowIndex) {
      const indexOf = this.purchases.findIndex((p) => p.id == row.id);
      this.purchases.splice(indexOf, 1);
      this.handleClick();
      this.computeAmount();
    },
    computeAmount() {
      const self = this;
      self.settleObj.amount = 0;
      self.settleObj.productQuantity = 0;
      for (const purchase of self.purchases) {
        self.settleObj.amount =
          Number(purchase.settleTotal) + self.settleObj.amount;
        self.settleObj.productQuantity =
          purchase.quantity + self.settleObj.productQuantity;
      }
      self.settleObj.orderQuantity = self.purchases.length;
    },
    //
    saveSubmit() {
      let self = this;
      if (self.purchases.length === 0) {
        this.$message({
          message: self.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      for (const o of self.purchases) {
        if (!Util.regexPrice(o.settleTotal)) {
          self.$message({
            message: self.$t("rules.regex", [
              self.$t("settlement.settleTotal"),
            ]),
            type: "warning",
          });
          return;
        }
      }
      self.settleObj.currency = "CNY";
      self.settleObj.settlementItems = self.purchases.map((p) => {
        return {
          recordUuid: p.uuid,
          settleTotal: p.settleTotal,
          explain: p.explain,
        };
      });

      self.saveDoing = true;
      Settlement.create(self.settleObj).then(function (res) {
        self.saveDoing = false;
        if (res.status == 200) {
          self.$message({
            message: self.$t("prompt.addSuccess"),
            type: "success",
          });
          self.$router.push({ name: "fnReportsSupplierSettlements" });
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.name {
  text-overflow: ellipsis;
  overflow: hidden;
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
}
</style>